document.addEventListener('DOMContentLoaded',  ()=> {
  setTimeout(() => {
      BSS_B2B.cart.fixer(JSON.parse($('#bss-b2b-store-data').html()), false, true)
  }, 1000)
  const optionsVariants = document.querySelectorAll('fieldset label')
  if(optionsVariants.length) {
    optionsVariants.forEach((option) => {
      option.addEventListener('click', () => {
        setTimeout(() => {
          BSS_B2B.changeProductPriceWithInterval()
        }, 200)
      })
    })
  }
})

// cart slider and cart page
document.addEventListener("BSS:openCartSlider", e => {
  addStyle();
  BSS_B2B.cart.fixer(BSS_B2B.shopData, 0, 0);
});

document.addEventListener("BSS:changeQty", e => {
  addStyle();
});
document.addEventListener("BSS:removeItemCart", e => {
  addStyle();
});
function addStyle() {
  if (!document.querySelector('style[data-style="cart-fixer"]')) {
      let style = document.createElement('style');
      style.type = 'text/css';
      style.setAttribute('data-style', 'cart-fixer');
      style.innerHTML = '.drawer__footer #CartDrawer-Checkout, .cart__footer #checkout { pointer-events: none !important; opacity: 0.6 !important; }';
      document.head.appendChild(style);
  }
}

function removeStyle() {
    let style = document.querySelector('style[data-style="cart-fixer"]');
    if (style) {
        document.head.removeChild(style);
    }
}

window.addEventListener('bss_b2b_cart_fixer_done', () => {
  console.log("bss_b2b_cart_fixer_done")
  setTimeout(() => {
    removeStyle();
  }, 1000)
})

if(typeof BSS_B2B !== "undefined") {
  window.addEventListener("cart_changed", () => {
      setTimeout(() => {
        let storeData = JSON.parse($("#bss-b2b-store-data").html());
        BSS_B2B.cart.fixer(storeData, null, false);
        BSS_B2B.handleCartCheckoutBtn(storeData);
      }, 500);
    });

  setTimeout(() =>{
    function handleButtonClick(e) {
      e.preventDefault();
      const $button = $(this);
      let oldText = $(this).text();
      $button.css({'pointer-events': 'none', 'opacity': '0.6'});
      $button.text("Loading ...");
      setTimeout(() =>{
        $button.css({'pointer-events': 'unset', 'opacity': '1'})
          $button.text(oldText);
      }, 2000);
    }
   
   $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
  }, 500)
}